var _ellipse, _rect, _rect2, _ellipse2, _ellipse3, _path, _g, _rect3, _rect4, _circle, _rect5, _circle2, _path2, _path3, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLevel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 155,
    viewBox: "0 0 154 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.004,
    cy: 63.7288,
    rx: 44.5528,
    ry: 42.4644,
    fill: "#24C2F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.3962,
    y: 20.8627,
    width: 27.0275,
    height: 19.4919,
    rx: 2,
    transform: "rotate(-30.018 87.3962 20.8627)",
    fill: "#24C2F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.1719,
    y: 0.380554,
    width: 27.0275,
    height: 19.4919,
    rx: 2,
    transform: "rotate(52.5921 86.1719 0.380554)",
    fill: "#24C2F3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6392,
    cy: 50.5022,
    rx: 2.08841,
    ry: 2.78455,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.7774,
    cy: 51.8949,
    rx: 2.08841,
    ry: 2.78455,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0591 65.2305C62.6916 65.5031 62.6125 66.0241 62.9102 66.3716C63.8537 67.4732 64.9933 68.3939 66.2737 69.0855C67.7973 69.9086 69.4831 70.3873 71.212 70.4877C72.9408 70.5882 74.6707 70.3079 76.2794 69.6668C77.6312 69.1281 78.8698 68.3457 79.9346 67.3607C80.2704 67.05 80.2523 66.5234 79.9188 66.2101C79.5854 65.8967 79.0633 65.9159 78.7239 66.2227C77.8277 67.033 76.7926 67.6788 75.6661 68.1277C74.2826 68.6791 72.7949 68.9201 71.3081 68.8337C69.8212 68.7473 68.3715 68.3357 67.0611 67.6278C65.9942 67.0514 65.0408 66.2901 64.2445 65.3815C63.9429 65.0374 63.4265 64.9579 63.0591 65.2305Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_142_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.928 87.354H29.4896C27.9984 87.354 27.0316 88.9271 27.7052 90.2575L41.7573 118.01C42.0979 118.682 42.7877 119.106 43.5416 119.106H130.038C130.838 119.106 131.561 118.629 131.876 117.894L143.766 90.1416C144.332 88.8219 143.364 87.354 141.928 87.354Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 78.03,
    width: 54.4117,
    height: 2.76106,
    rx: 1.38053,
    transform: "rotate(37.1195 88.7 78.03)",
    fill: "#8D705F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120.111,
    y: 113.018,
    width: 17.9469,
    height: 20.708,
    rx: 2,
    transform: "rotate(-47.5355 120.111 113.018)",
    fill: "#8D705F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.713,
    cy: 89.4248,
    r: 8.97345,
    fill: "#24C2F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 53.176,
    height: 2.76106,
    rx: 1.38053,
    transform: "matrix(-0.797379 0.603479 0.603479 0.797379 57.5312 75.6397)",
    fill: "#8D705F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.492,
    cy: 82.5222,
    r: 8.97345,
    fill: "#24C2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8114 132.221C45.541 132.221 46.9659 130.812 46.7219 129.1C46.0252 124.212 43.7054 119.643 40.0693 116.114C35.668 111.842 29.6985 109.443 23.4742 109.443C17.2498 109.443 11.2803 111.842 6.87905 116.114C3.24287 119.643 0.923097 124.212 0.226441 129.1C-0.0175997 130.812 1.40729 132.221 3.13694 132.221C4.86659 132.221 6.23836 130.806 6.57017 129.109C7.20957 125.838 8.84781 122.801 11.3081 120.413C14.5347 117.281 18.911 115.522 23.4742 115.522C28.0373 115.522 32.4136 117.281 35.6402 120.413C38.1005 122.801 39.7387 125.838 40.3781 129.109C40.71 130.806 42.0817 132.221 43.8114 132.221Z",
    fill: "#24C2F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1317 131.779C42.4021 131.779 40.9772 130.37 41.2212 128.657C41.9179 123.769 44.2377 119.201 47.8739 115.672C52.2751 111.4 58.2446 109 64.469 109C70.6933 109 76.6628 111.4 81.0641 115.672C84.7002 119.201 87.02 123.769 87.7167 128.657C87.9607 130.37 86.5358 131.779 84.8062 131.779C83.0765 131.779 81.7048 130.364 81.3729 128.666C80.7335 125.395 79.0953 122.358 76.635 119.971C73.4084 116.839 69.0321 115.079 64.469 115.079C59.9058 115.079 55.5295 116.839 52.3029 119.971C49.8426 122.358 48.2044 125.395 47.565 128.666C47.2332 130.364 45.8614 131.779 44.1317 131.779Z",
    fill: "#24C2F3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 17.9469,
    height: 20.708,
    rx: 2,
    transform: "matrix(-0.675133 -0.737696 -0.737696 0.675133 30.1589 108.876)",
    fill: "#8D705F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_142_183",
    x: 17.4871,
    y: 81.354,
    width: 136.443,
    height: 51.7522,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_142_183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_142_183",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLevel2);
export default __webpack_public_path__ + "static/media/UserLevel2.6bb85fca8d9a193a29fdd5377587bebb.svg";
export { ForwardRef as ReactComponent };